import { categoryListStyles } from "@insite/content-library/Widgets/Category/CategoryList";
import { css } from "styled-components";

categoryListStyles.categoryImageItem = {
    width: 12,
    css: css`
        height: 160px;
        justify-content: center;
    `,
};

categoryListStyles.categoryImage = {
    width: "160px",
    height: "160px",
    css: css`
        border-radius: 50%;
        background: #f3efeb;
    `,
};
categoryListStyles.categoryNameLinkItem = {
    width: 12,
    css: css`
        padding-bottom: 8px;
        justify-content: center;
    `,
};
categoryListStyles.categoryName = {
    color: "primary",
    css: css`
        font-weight: bold;
    `,
};
